import { forwardRef } from 'react';

import usePostMessages from 'src/hooks/usePostMessages';

const IFrame = forwardRef(({ src, callbacks, ...rest }, ref) => {
    usePostMessages(callbacks);

    return <iframe ref={ref} {...rest} src={src} />;
});

export default IFrame;
